<template>
  <div class="bg-gray">
    <div class="form-content">
      <el-form
          :model="formData"
          ref="ruleForm"
          :rules="rules"
          label-width="100px"
          class="demo-ruleForm"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="赛区:" prop="name">
              {{formData.saiqu.name}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="单位:" prop="name">
              {{formData.baoming.danwei}}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="队伍名称:" prop="name">
              {{formData.baoming.mingcheng}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="项目:" prop="name">
              {{formData.subject_name}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="视频" prop="grade">
              <VideoUploader :fileList="formData.video" :limit="1"></VideoUploader>
              <div class="form-label-desc">请上传一段视频</div>
            </el-form-item>
          </el-col>


          <el-col :span="12"  v-if="formData.subject_name.indexOf('活力大课间啦啦操展示')>=0">
            <el-form-item label="运动员人数" >
              <el-input-number style="width: auto !important" v-model="formData.yundongyuan_count" :min="0" :max="3000" />
                <br/> 如果不上传运动员信息，请填写运动员人数
            </el-form-item>


              <el-form-item label="参赛运动员" >  
                    <el-button type="text" @click="download">先下载导入模版</el-button> 
                    <van-uploader
                        accept=".xls,.xlsx"
                        :after-read="readFile"
                    >
                      <el-button  
                          size="normal">再批量导入
                      </el-button>
                    </van-uploader>
                    <p style="color: #666;">运动员姓名将显示在比赛证书上，<span style="color: #ff0000">请谨慎填写<br/>如果不填写运动员，后期将无法导出证书。</span></p>
              
                    
                <div v-show=formData.yundongyuan.length>
                  <div class="memberLi" v-for="(yundongyuan ,index) in formData.yundongyuan" :key=index>
                    运动员{{ index + 1 }}
                    <el-tag
                        :key="index"
                        round
                        closable
                        type="primary"
                        @close="formData.yundongyuan.splice(index,1)"
                    > {{ yundongyuan.name }}  
                    </el-tag>
                  </div>
                </div>
              </el-form-item>
          </el-col>
        </el-row>
 


        <el-row>
          <el-col class="footer-button">
            <el-button type="primary" @click="submitForm('ruleForm')" :loading="saveLoading">保存
            </el-button>
            <el-button @click="resetForm('ruleForm')" plain v-if="false">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
      <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>
    </div>
  </div>
</template>
<style scoped>
.box {
  /*margin-bottom: 1.5rem;*/
}

.memberResultWrap {
  background: #F3F3F3;
  margin: 0.2rem;
  border-radius: 8px;
  padding: 0.2rem;
}

.memberResultWrap .memberLi {
  font-size: 14px;
  color: #666;
  height: 36px;
  line-height: 36px;
}

.memberResultWrap .memberLi .van-tag {
  width: auto !important;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


.van-tag {
  width: 55px;
  margin-left: 10px;
  text-align: center;
}

.between {
  justify-content: space-between;
}


</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import VideoUploader from '@/components/picker/VideoUploader.vue';

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Dialog,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button
} from 'vant';
import CaipanPicker from '@/components/picker/CaipanPicker.vue';
import JiaolianPicker from '@/components/picker/JiaolianPicker.vue';
import LoginDialog from '@/components/LoginDialog.vue';
import XLSX from "xlsx";

Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(RadioGroup).use(Dialog).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'SaiApplyFormStep1',
  components: {
    [Field.name]: Field,
    PicUploader,
    VideoUploader,
    CaipanPicker,
    JiaolianPicker,
    LoginDialog
  },
  data: function () {
    return {
      validator,
      loginShow: false,
      canSubmit: false,
      saveLoading: false,
      showCaipanPicker: false,
      showJiaolianPicker: false,
      showNumTypePicker: false,
      numTypeColumns: ['身份证', '护照'],
      showArea: false,
      rules: {},
      areaList: {},
      areaValue: '',
      submitType: '',
      formData: {
        id: 0,
        baoming: {},
        saiqu: {},
        pic: [],
        yundongyuan:[],
        yundongyuan_count: 0,
        video: [
          {
            name: "xxxx.mov",
            save_name: "h5/2020-05-26/1590474953142781.mov",
            uid: "vc-upload-1590474953142781",
            url: "https://ccago.oss-cn-hangzhou.aliyuncs.com/h5/2020-05-26/1590474953142781.mov"
          }
        ],
//                            [{name:"选择商户.png",
//                        save_name:"h5/2020-05-11/1589187988243621.png",
//                        uid:"vc-upload-1589187988243621",
//                        url:"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-05-11/1589187988243621.png"
//                    }],
      },
    }
  },
  filters: {},
  mounted() {
    let that = this;
    that.formData.id = this.$route.query.id;
    document.title = '上传视频';
    that.fetch();

    window.rbMessage = function (data) {
      data = JSON.parse(data);
//                alert(data);
      if (data[0] == 'videoUploadSuccess') {
        that.formData.video = [data[1]];
      }
    }
  },
  watch: {
    formData() {
    }
  },
  destroyed() {
  },
  methods: {
    fetch() {
      let that = this;
      that.$api.get('/api/isai/videoDetail', {
        id: that.formData.id,
      }, (res) => {
        that.formData = Object.assign(that.formData, res.data);
        if (res.data.baoming.memberstatus != 6) {
          Toast("报名尚未成功,无法进行操作");
        } else {
          that.canSubmit = true;
        }

      }, (res) => {
        console.log('没有登录');
        if (res.code == 401 || res.code == 402) {
          that.loginShow = true
        } else {
          Toast(res.msg)
        }
      })
    },
    onQuestion() {
      console.log('onQuestion')
    },
    onSubmit(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;
      console.log(that.formData)
      that.formValidate = true;
      for (let field in that.formData) {
        if (that.formData.pic.length == 0) {
          Toast('请上传照片');
          return
        }
        if (this.formData.video.length == 0) {
          Toast('请上传视频');
          return
        }
      }
      that.saveLoading = true;
      that.$api.post('/api/isai/savesubjectvideo', that.formData, (res) => {
        that.saveLoading = false;

        appEvent({
          name: 'saiApplyVideoReload',
          query: {}
        });
        appEvent({
          name: 'saiApplyDetailReload',
          query: {}
        }); 
        setTimeout(() => {
          rbLink({
            'name': 'ISaiApplyVideoList',
            'query': {
              id: that.formData.baoming.id,
            }
          }, 'back')
        }, 1000)
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },
    save(values) {
      this.submitType = 'save';
    },
    onVideoInputClick() {
      let that = this;
      console.log({
        name: 'onVideoInputClick',
        query: {
          'mingcheng': this.formData.baoming.mingcheng,
          'subject_name': this.formData.subject_name,
        }
      });

      appEvent({
        name: 'onVideoInputClick',
        query: {
          'mingcheng': this.formData.baoming.mingcheng,
          'subject_name': this.formData.subject_name,
        }
      });
    },
    submitForm(formName) {
      const that = this;
      // 拿到地区的 省市区名称

      for (let field in that.formData) {
        if (that.formData.pic.length == 0) {
          // Toast('请上传照片');
          // return
        }
        if (this.formData.video.length==0) {
          this.$message.info('请上传视频');
          return
        }
      }
      that.saveLoading = true;
      that.$api.post('/api/isai/savesubjectvideo', {
        'id' : that.formData.id,
        'yundongyuan' : JSON.stringify(that.formData.yundongyuan),
        'video' : that.formData.video,
        'pic' : that.formData.pic,
        'jizan_pic' : that.formData.jizan_pic,
        'jizan_count' : that.formData.jizan_count,
        'yundongyuan_count' : that.formData.yundongyuan_count,
      }, (res) => {
        that.saveLoading = false;
        console.log('that.$route.query.from', that.$route.query.from);
        // return 

        if(that.$route.query.from == 'app'){
          Toast('上传成功');
          return 
        }

        setTimeout(() =>{
          rbLink({
            'name' : 'ISaiApplyVideoList',
            'query':{
              id:that.formData.baoming.id,
            }
          },'back')
        },50)
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    download(){
      window.open('https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/%E6%B4%BB%E5%8A%9B%E5%A4%A7%E8%AF%BE%E9%97%B4%E8%BF%90%E5%8A%A8%E5%91%98%E4%BF%A1%E6%81%AF%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx', '_blank');
    },
    readFile(evt) {
      console.log('------readFile------', evt)
      var that = this; 

      let files = {0: evt.file}

      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: 'binary'
          });
          const wsname = workbook.SheetNames[0];//取第一张表
          var list = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]);//生成json表格内容

          if (that.startNum) {
            list = list.splice(that.startNum, list.length)
          }

          list = list.filter(row => {
            return row.hasOwnProperty("姓名") && String(row['姓名']).replace(/\s+/g, '') != ''
          })

          let rlist =[]

          list.map(row => {
            rlist.push({
              name: row['姓名'],
              num: 'n'+row['姓名'], 
              cardtype: 3,
              birthday: '',
              sex: 0,
            })
          })
 
          this.formData.yundongyuan = [...rlist];

          // that.listData = list 
          // console.log('onGetData', list)
        
          return 
 

        } catch (e) {
          console.log(e)
          return false;
        }
      };
      fileReader.readAsBinaryString(files[0]);
    },

    loginSuccess(res) {
      console.log('-------登录成功--------', res);
      this.loginShow = false;
      this.fetch();
    },

    loginCancel() {
      console.log('-------取消登录--------');
      // this.loginShow = false;
    },
  }
}
</script>



// WEBPACK FOOTER //
// SaiApplyFormUploadVideo.vue?5e3c2c18